export default [
  {
    title: 'breadcrumb.call',
    route: 'call',
    icon: 'PhoneCallIcon',
    resource: 'customer-call',
    action: 'read',
    tag: 0,
    tagVariant: "danger",
  },
];